import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { DummyComponent } from '../../../shared/dummy.component';
import * as FileSaver from 'file-saver';
import { consts } from '../../../consts';
import { Utils } from '../../../shared/utils';
import { CreditosConEmpleadosService } from './creditos-con-empleados.service';
import { CreditosConEmpleadosConst } from './creditos-con-empleados-const';
import { CreditosConEmpleadosModel } from './creditos-con-empleados.model';
import { CreditosConEmpleadosDialogDeleteComponent } from './creditos-con-empleados-dialog-delete.component';
import { CreditosConEmpleadosDialogAttachmentComponent } from './creditos-con-empleados-dialog-attachment.component';
import { CreditosConEmpleadosDialogCobroCuotasComponent } from './creditos-con-empleados-dialog-cobro-cuotas.component';
import { CreditosConEmpleadosDialogDeudaACortoPlazoComponent } from './creditos-con-empleados-dialog-deuda-a-corto-plazo.component';
import { CreditosConEmpleadosDialogConstitucionCreditoComponent } from './creditos-con-empleados-dialog-constitucion-credito.component';
import { AccountingManualFormComponent } from '../../accounting/manual/accounting-manual-form.component';
import { TableService } from '../../../shared/components/table/table.service';

@Component({
    selector: 'convfact-creditos-con-empleados-list',
    templateUrl: './creditos-con-empleados-list.component.html',
    styleUrls: ['./creditos-con-empleados.component.css'],
    standalone: false
})
export class CreditosConEmpleadosListComponent implements OnInit {
  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;

  public headerTable: any[] = CreditosConEmpleadosConst.headerTable;

  public dataSource: CreditosConEmpleadosModel[] = [];

  public empty: boolean = false;
  public ready: boolean = false;
  public spinner: boolean = false;

  public download: boolean = false;
  public empty_guid = consts.EMPTY_GUID;

  constructor(
    private creditosConEmpleadosService: CreditosConEmpleadosService,
    private router: Router,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public dummy: DummyComponent,
    private tableService: TableService
  ) { }

  public ngOnInit(): void {
    this.dataSource = [];
    this.getList();
  }

  public getList() {
    this.creditosConEmpleadosService.list(this.currentPage, this.itemsPerPage)
      .then(data => {
        this.tableService.set(data.list);
        this.dataSource = data.list;
        this.totalItems = data.totalItems;
        if (this.dataSource.length === 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.ready = true;
      });
  }

  public pageChanged(event: any) {
    this.currentPage = event.page;
    this.getList();
  }

  public constitucionCredito(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    // Buscamos el obtejo de inversion y se lo pasamos al modal de pago
    const creditosconempleadosSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(CreditosConEmpleadosDialogConstitucionCreditoComponent, {
      // height: '60%',
      // width: '70%',
      data: { creditosconempleados: creditosconempleadosSelected }
    })
      .afterClosed().subscribe(() => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public deudaACortoPlazo(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    // Buscamos el obtejo de inversion y se lo pasamos al modal de pago
    const creditosconempleadosSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(CreditosConEmpleadosDialogDeudaACortoPlazoComponent, {
      // height: '60%',
      // width: '70%',
      data: { creditosconempleados: creditosconempleadosSelected }
    })
      .afterClosed().subscribe(() => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public cobrarCuotas(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    // Buscamos el obtejo de inversion y se lo pasamos al modal de pago
    const creditosconempleadosSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(CreditosConEmpleadosDialogCobroCuotasComponent, {
      // height: '60%',
      // width: '70%',
      data: { creditosconempleados: creditosconempleadosSelected }
    })
      .afterClosed().subscribe(() => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public create() {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.router.navigate([this.router.url + '/create']);
  }

  public edit(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.router.navigate([this.router.url + '/edit' + '/' + uid]);
  }

  public delete(uid: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(CreditosConEmpleadosDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public uploadFileAttachment(uid: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(CreditosConEmpleadosDialogAttachmentComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public downloadFileAttachment(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.creditosConEmpleadosService.downloadFileAttachment(uid).then(response => {
      FileSaver.saveAs(response, Utils.GetFileName("Fichero_Adjunto", consts.EXT_EXCEL));
    })
  }

  public displayInfo(response: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(response, '', options);
  }

  public addManualAccountMovements(): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog
      .open(AccountingManualFormComponent, {
        width: '60%',
        height: '70%',
        data: {
          accountingMovementId: ''
        }
      })
      .afterClosed().subscribe((result: string) => {
        if (!Utils.IsNullOrEmpty(result)) {
          if (result === 'OK') {
            this.dummy.redirectTo(this.router.url);
          }
        }
      });
  }

  public trackByIndex(i: number) { return i; }

}
